<template>
	<div class="row mx-0" style="padding-left: 1.5rem; position: relative;">

		<button :title="'Unaugmented Field\nClick to unlock for editing.'" :class="{ 'd-none': !isAugState( false ) }" class="btn btn-secondary mt-1" @click.prevent="cycleAugmentingMode" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-lock"></i></button>
		<button :title="'Augmented: Replaced\nClick to hide field.'" :class="{ 'd-none': !isAugState( true ) }" class="btn btn-success mt-1" @click.prevent="cycleAugmentingMode" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-lock-open"></i></button>

		<!-- object field name entry (object only) -->
		<div class="col-4 p-0 text-nowrap pr-2" style="min-width: 200px; margin-left: -1.5rem !important;">
			<input type="text" class="form-control mt-1" value="$schema" style="display: inline !important;" disabled>
			<label class="col-form-label font-weight-bold mt-1" style="display: inline !important;">:</label>
		</div>

		<!-- schema entry type selector -->
		<div class="col-2 pl-1 pr-0" style="min-width: 140px; width: 100%;">
			<select :disabled="disabled || !allowNoSchema || augment" class="form-control mt-1" v-model="mode">
				<option v-if="allowNoSchema" value="none">None</option>
				<option value="local">Local Schema</option>
				<option value="address" disabled>(soon) Address Reference</option>
				<option value="jsonschema" disabled>(soon) JSON Schema</option>
			</select>
		</div>

		<!-- value entry controls -->
		<div class="pl-1 pr-0" :class="getValueTypeClass(item.type)" style="min-width: 200px;">
			<!-- compact types -->
			<!-- <input :disabled="disabled" v-if="item.type === 'string.short'" v-model="item.value" type="text" class="form-control mt-1" placeholder="[Schema Name]"> -->
			
			<select v-if="mode === 'local' && schemaList.length === 0" disabled>
				<option selected>(No Valid Schemas Found)</option>
			</select>
			<select v-if="mode === 'local' && schemaList.length > 0" :disabled="disabled || ( augment && !augmenting )" :id="( htmlId ? htmlId : undefined )" class="form-control mt-1" v-model="schemaValue.local">
				<option v-for="schema in schemaList" :key="schema.$id" :value="schemaName(schema.$id)">{{schemaName( schema.$id )}}</option>
			</select>
			<input v-if="mode === 'none'" placeholder="(No Schema - Unstructured)" type="text" class="form-control mt-1" disabled>
			<input v-if="mode === 'address'" placeholder="(FUTURE: Ecosystem Schema Address)" type="text" class="form-control mt-1" disabled>
			<input v-if="mode === 'jsonschema'" placeholder="(FUTURE: JSON Schema URL)" type="text" class="form-control mt-1" disabled>
		</div>
	</div>
</template>

<script>
import ObjectEditorItem from "@/components/utilities/ObjectEditorItem";

const REGEX_WN_SCHEMA_REF = /^(([a-z_-]+\/)?([a-z_-]+:))?([a-z_-]+\.)+$/i;
const REGEX_WN_SCHEMA_LOCAL = /^([a-z_-]+\.)+$/i;

export default {
	name: "object-editor-schema",
	extends: ObjectEditorItem,
	props:
	{
		source: { type: null, required : false },
	},
	data() {
		return {
			mode : 'none',
			schemaValue:
			{
				local : '',
				address : '',
				jsonschema : ''
			},
			initialSchema : undefined
		};
	},
	watch:
	{
		mode( newVal, oldVal )
		{
			if( newVal == oldVal )
				return;	// Do nothing.
			
			this.setSchemaMode( newVal );
		},
		'schemaValue.local' : function( newVal, oldVal )
		{
			if( newVal )
				this.$set( this.activeItem, 'value', newVal );
			else
				this.$delete( this.activeItem, 'value' );
		},
		'item.type' : function( newVal, oldVal )
		{
			this.initSchema( );
		},
		augment( newVal, oldVal )
		{
			if( newVal && this.initialSchema )
			{
				if( !this.schemaAllowed( this.schemaValue.local ) )
					this.$set( this.schemaValue, 'local', this.initialSchema );
			}
		},
		'schemas.compiled' : function( newVal, oldVal )
		{
			if( newVal && Object.keys( newVal ).length > 0 )
			{
				if( this.initialSchema && !this.schemaAllowed( this.initialSchema ) )
				{
					delete this.initialSchema;
					this.initSchema( );
				}
				if( !this.initialSchema && Array.isArray( this.allowedSchemas ) && this.allowedSchemas.length > 0 )	// No initialSchema. If allowedSchemas, preset the first one.
				{
					console.warn( "SETTING ALLOWED SCHEMA:", this.allowedSchemas[0] );
					this.setSchemaMode( 'local' );
					this.$set( this.schemaValue, 'local', this.allowedSchemas[0] );
				}
			}
		},
		'activeItem.value' : function( newVal, oldVal ) {
			this.initSchema( );
		}
	},
	computed:
	{
		schemaList( )
		{
			const list = [];
			for( let i=0; i < this.schemas.raw.length; i++ )
			{
				const schema = this.schemas.raw[i];
				if( this.schemaAllowed( schema.$id ) )
					list.push( schema );
			}
			return list;
		},
		allowNoSchema( )
		{
			if( this.augment && this.initialSchema )
				return false;
			if( Array.isArray( this.allowedSchemas ) && this.allowedSchemas.length > 0 )
				return false;
			return true;
		}
	},
	created( )
	{
		if( REGEX_WN_SCHEMA_LOCAL.test( this.item.value ) )
			this.initialSchema = this.item.value;
		
		// Set the [mode] based on [item] value, etc.
		this.initSchema( );
	},
	methods:
	{
		cycleAugmentingMode( )
		{
			this.augmenting = !this.augmenting;
			//console.log( "### ACTIVE ITEM:", JSON.stringify( this.activeItem ) );
		},
		schemaAllowed( schemaIdOrName )
		{
			if( !schemaIdOrName || typeof schemaIdOrName !== 'string' )
				throw new TypeError( "Must provide a [schemaIdOrName], which is a string!" );

			const schemaName = this.schemaName( schemaIdOrName );

			//console.log( `INITIAL SCHEMA: ${this.initialSchema} vs. ${schemaName} vs. ${JSON.stringify( this.allowedSchemas )}` );

			if( this.augment && this.initialSchema && !schemaName.startsWith( this.initialSchema ) )
				return false;

			if( Array.isArray( this.allowedSchemas ) )
			{
				for( const s of this.allowedSchemas )
					if( schemaName.startsWith( s ) )
						return true;
				return false;
			}

			return true;
		},
		initSchema( )
		{
			if( this.activeItem.type == 'none' || !this.activeItem.value )
				this.mode = 'none';
			else
			{
				this.mode = 'local';
				this.$set( this.schemaValue, 'local', this.activeItem.value );
			}
		},
		schemaName( id )
		{
			return id.substring( id.indexOf( ':' ) + 1 );
		},
		setSchemaMode( mode )
		{
			switch( mode )
			{
				case 'local':
				{
					if( !this.schemaValue.local && this.schemaList.length > 0 )
						this.$set( this.schemaValue, 'local', this.schemaName( this.schemaList[0].$id ) );
					this.$set( this.activeItem, 'type', 'string.short' );
					this.$set( this.value, 'string', this.schemaValue.local );
					break;
				}
				case 'address':
				{
					// Unsupported - fall through to "none" for now.
				}
				case 'jsonschema':
				{
					// Unsupported - fall through to "none" for now.
				}
				case 'none':
				{
					this.$set( this.activeItem, 'type', 'none' );
					break;
				}
				default:
				{
					console.warn( "UNKNOWN SCHEMA MODE:", mode );
				}
			}
		}
	}
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/ObjectEditorSchema.vue